// removed by extract-text-webpack-plugin
module.exports = {"container":"_2GUc1mBoYCL5WbyUlIz6ue"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/Layout/styles.css
// module id = 3151
// module chunks = 0